export default {
  'Teklif Formu': 'Форма Предложения',
  'Kayıtlı Teklifler': 'Сохраненные Предложения',
  'Kullanıcı Adı': 'Имя Пользователя',
  'Şifre': 'Пароль',
  'Giriş Yap': 'Войти',
  'Çıkış Yap': 'Выйти',
  'KDV Oranı': 'Ставка НДС',
  'Teklif Durumu': 'Статус Предложения',
  'Kaydet': 'Сохранить',
  'PDF Önizleme': 'Предварительный Просмотр PDF',
  'PDF\'ye Aktar': 'Экспорт в PDF',
  'E-posta ile Gönder': 'Отправить по Email',
  'Alıcı': 'Получатель',
  'Tarih': 'Дата',
  'Genel Toplam': 'Общий Итого',
  'Not': 'Примечание',
  'KDV': 'НДС',
  'Alt Toplam': 'Подытог',
  'Açıklama': 'Описание',
  'Ürün Adı': 'Название Продукта',
  'SUT Kodu': 'Код SUT',
  'Birim Alış Fiyatı': 'Цена за Единицу',
  'Sipariş Adedi': 'Количество Заказа',
  'Promosyon Ürün': 'Промо Продукт',
  'Toplam Adet': 'Общее Количество',
  'Sipariş Tutarı': 'Сумма Заказа',
  'Durum': 'Статус',
  'Kabul Edildi': 'Принято',
  'Reddedildi': 'Отклонено',
  'Gönderildi': 'Отправлено',
  'Taslak': 'Черновик',
  'Yurtiçi': 'Внутренний',
  'Yurtdışı': 'Международный',
  'Sipariş Oluştur': 'Создать Заказ',
  'Ürün Sıralaması': 'Сортировка Продуктов',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Продукты отсортированы по популярности и важности',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Продукты кардиологии и сосудистой хирургии отображаются как приоритетные',
  'Ürün adı, açıklama veya barkod ile ara...': 'Поиск по названию продукта, описанию или штрих-коду...',
  'Tüm Kategoriler': 'Все Категории',
  'Kutu görünüm': 'Вид сетки',
  'Liste görünüm': 'Вид списка',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Не найдено продуктов, соответствующих вашим критериям',
  'Ürün Adı Yok': 'Нет Названия Продукта',
  'Kategori Yok': 'Нет Категории',
  'Açıklama yok': 'Нет описания',
  'Firma Bilgilerini Doldurun': 'Заполнить Информацию о Компании',
  'Sepete Ekle': 'Добавить в Корзину',
  'Firma Bilgileri': 'Информация о Компании',
  'Ülke Seçimi': 'Выбор Страны',
  'Türkiye': 'Турция',
  'Almanya': 'Германия',
  'ABD': 'США',
  'Firma Ünvanı': 'Название Компании',
  'Vergi Dairesi': 'Налоговая Инспекция',
  'Vergi Numarası': 'ИНН',
  'Adres': 'Адрес',
  'Şehir': 'Город',
  'Şehir Seçimi': 'Выбор Города',
  'Şehir Seçiniz': 'Выбрать Город',
  'Şehir adı ara...': 'Поиск названия города...',
  'Aradığınız şehir bulunamadı': 'Город не найден',
  'Bu ülke için şehir verisi bulunamadı': 'Данные о городах для этой страны недоступны',
  'şehir bulundu': '{{count}} городов найдено',
  'Yetkili': 'Уполномоченное Лицо',
  'Telefon': 'Телефон',
  'Email': 'Email',
  'Bilgileri İlet': 'Отправить Информацию',
  'Lütfen eksik alanları doldurun': 'Пожалуйста, заполните недостающие поля',
  'Firma kaydedilemedi': 'Компания не была сохранена',
  'Firma bilgileri başarıyla iletildi': 'Информация о компании успешно отправлена',
  'Firma Ünvanı:': 'Название Компании:',
  'Yetkili Kişi:': 'Уполномоченное Лицо:',
  'Sepetiniz': 'Ваша Корзина',
  'Sepetiniz boş': 'Ваша корзина пуста',
  'adet': 'шт',
  'Düzenle': 'Редактировать',
  'Kaldır': 'Удалить',
  'Siparişi Tamamla': 'Завершить Заказ',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Пожалуйста, сначала отправьте полную информацию о вашей компании',
  'Sipariş başarıyla kaydedildi': 'Заказ успешно сохранен',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Приветственное сообщение и ссылка для доступа отправлены на ваш email',
  'Link 3 gün geçerlidir': 'Ссылка действительна 3 дня',
  'Sipariş kaydedilemedi': 'Заказ не был сохранен',
  'Firma Bilgileri Gerekli': 'Требуется Информация о Компании',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Сначала заполните информацию о компании для добавления в корзину',
  'Önce Bilgileri Doldurun': 'Сначала Заполните Информацию',
  'Uyarı': 'Предупреждение',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Вы должны сначала заполнить информацию о компании для добавления в корзину',
  'SUT Kütüphanesi Tanımı': 'Определение Библиотеки SUT',
  'SUT Kodu:': 'Код SUT:',
  'Standart': 'Стандарт',
  'Açıklama (isteğe bağlı)': 'Описание (необязательно)',
  'Partner Ol': 'Стать Партнером',
  'Partner başvuru popup açılacak': 'Откроется всплывающее окно заявки партнера',
  'Dil': 'Язык',
  'E-posta': 'Email',
  'E-Posta': 'Email',
  'Şifre': 'Пароль',
  'Şifremi Unuttum': 'Забыл Пароль',
  'Giriş yapılıyor...': 'Вход в систему...',
  'E-posta veya şifre hatalı': 'Неверный email или пароль',
  'Şifre sıfırlama e-postası gönderildi': 'Email для сброса пароля отправлен',
  'E-posta gönderilemedi': 'Email не был отправлен',
  'Üye Ol': 'Зарегистрироваться',
  'Üye Değil Misiniz?': 'Не являетесь членом?',
  'Şimdi Üye Ol': 'Зарегистрироваться Сейчас',
  'Misafir Kullanıcı': 'Гостевой Пользователь',
  'Hızlı Sipariş': 'Быстрый Заказ',
  'Misafir Olarak Sipariş Verin': 'Заказать как Гость',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Быстро выберите ваши продукты и создайте заказ без входа в систему',
  'Giriş yapmadan sipariş oluşturun': 'Создать заказ без входа в систему',
  'Anında Erişim': 'Мгновенный Доступ',
  'Tüm ürünlere anında erişim': 'Мгновенный доступ ко всем продуктам',
  'Güvenli İşlem': 'Безопасная Транзакция',
  'SSL korumalı güvenli sipariş': 'Безопасный заказ, защищенный SSL',
  'Misafir Olarak Sipariş Oluştur': 'Создать Заказ как Гость',
  'İpucu:': 'Совет:',
  'Daha fazla özellik için üye olun': 'Зарегистрируйтесь для получения дополнительных функций',
  'Ücretsiz': 'Бесплатно',
  'Hızlı': 'Быстро',
  'Güvenli': 'Безопасно',
  'bayilikSozlesme': 'Я прочитал и принимаю условия и положения партнерства INVAMED.',
  'geri': 'Назад',
  'basvuruGonder': 'Отправить Заявку',
  'ileri': 'Далее',
  'sozlesmeGonderildi': 'Договор Отправлен на Ваш Email!',
  'sozlesmeDesc': 'Пожалуйста, загрузите Договор Партнерства INVAMED и необходимые документы, отправленные на ваш email ниже.',
  'tamamla': 'Завершить Заявку',
  'basvuruAlindi': 'Ваша Заявка Получена!',
  'basvuruAlindiDesc': 'Команда INVAMED рассмотрит вашу заявку и свяжется с вами в ближайшее время.',
  'Başvuru Durumu': 'Статус заявки',
  'Başvurunuz onay sürecindedir': 'Ваша заявка находится на рассмотрении',
  'sifreSifirla': 'Сброс Пароля',
  'sifreSifirlaDesc': 'Введите ваш зарегистрированный email, и мы отправим вам инструкции по сбросу пароля.',
  'gonder': 'Отправить',
  'talimatGonderildi': 'Инструкции Отправлены',
  'sentDesc': 'Инструкции по сбросу пароля отправлены на <b>{email}</b>. Пожалуйста, проверьте ваш email.',
  'helpTitle': 'Как я могу войти в систему?',
  'helpList': [
    'Для входа в панель дистрибьютора INVAMED введите ваш зарегистрированный email и пароль.',
    'Для входа с демо-пользователем:',
    'Если вы забыли пароль, используйте ссылку "Забыл Пароль" для запроса сброса.',
    'Если у вас проблемы со входом, убедитесь, что ваш email и пароль правильные. Если проблема сохраняется, свяжитесь с нашей командой поддержки.'
  ],
  'partnerlikSozlesmeTitle': 'Договор Партнерства INVAMED и Условия',
  'partnerlikSozlesmeText': `1. ОБЩИЕ ПОЛОЖЕНИЯ

Этот договор заключается между INVAMED (далее именуемая "Компания") и кандидатом в партнеры (далее именуемый "Партнер") в целях сотрудничества в продаже медицинских устройств и оборудования.

2. УСЛОВИЯ ПАРТНЕРСТВА

2.1. Партнер должен иметь законные полномочия для продажи медицинских устройств.
2.2. Партнер должен быть организацией, работающей в сфере здравоохранения.
2.3. Партнер должен иметь необходимые лицензии и сертификаты.
2.4. Партнер должен быть финансово надежным.

3. ОБЯЗАТЕЛЬСТВА СТОРОН

Обязательства Компании:
3.1. Предоставлять качественные продукты и услуги
3.2. Обеспечивать техническую поддержку
3.3. Предоставлять обучение и информацию
3.4. Быть прозрачными в ценообразовании

Обязательства Партнера:
3.1. Хранить продукты в соответствующих условиях
3.2. Обеспечивать качественное обслуживание клиентов
3.3. Соблюдать правовые нормы
3.4. Защищать бренд компании

4. ЦЕНООБРАЗОВАНИЕ И ОПЛАТА

4.1. Цены определяются Компанией
4.2. Партнер обязан поддерживать установленные цены
4.3. Условия оплаты определяются отдельно
4.4. Комиссионные ставки могут варьироваться в зависимости от производительности

5. КОНФИДЕНЦИАЛЬНОСТЬ И БЕЗОПАСНОСТЬ

5.1. Стороны обязаны защищать конфиденциальную информацию друг друга
5.2. Информация о клиентах должна храниться конфиденциально
5.3. Должны соблюдаться стандарты безопасности данных

6. СРОК ДЕЙСТВИЯ И РАСТОРЖЕНИЕ ДОГОВОРА

6.1. Этот договор действителен 1 год
6.2. Может быть продлен по взаимному согласию
6.3. Может быть расторгнут с уведомлением за 30 дней
6.4. Может быть расторгнут немедленно в случае серьезного нарушения

7. РАЗРЕШЕНИЕ СПОРОВ

7.1. Споры в первую очередь пытаются разрешить через переговоры
7.2. Суды Республики Турция уполномочены для неразрешенных случаев

8. ДЕЙСТВИТЕЛЬНОСТЬ

Этот договор прочитан, понят и принят сторонами.`,
  'partnerlikSozlesmeOnay': 'Я прочитал, понял и принимаю вышеуказанный Договор Партнерства INVAMED и Условия. Я заявляю, что принимаю все статьи этого договора и буду выполнять свои обязательства.',
  'sozlesmeyiGoruntule': 'Просмотреть Договор',
  'sozlesmeyiKapat': 'Закрыть',
  'Ürün': 'Продукт',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Выберите продукты из списка для добавления в корзину',
  'Etiketler': 'Теги',
  'Öncelikli': 'Приоритет',
  'Kapat': 'Закрыть',
  'globalPartnersTitle': 'Сотрудничество с 30,000 Партнеров по Всему Миру',
  'globalPartnersDesc': 'Наша обширная глобальная сеть из 30,000 партнеров стимулирует совместные инновации, обмен знаниями и взаимный успех. Работая вместе, мы постоянно расширяем границы ухода за пациентами.',
  'Yardım': 'Помощь',
  'dil': 'Язык',
  'Connect Free!': 'Подключиться бесплатно!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Откройте для себя наши самые популярные продукты',
  'Tüm Kategoriler': 'Все категории',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 товаров показано (Всего: 8000+)',
  'Tüm Ürünleri Gör →': 'Посмотреть все товары →',
  'Detaylar': 'Детали',
  'Sipariş Ver': 'Заказать',
  'Giriş Yap': 'Войти',
  'Hesabınıza giriş yapın': 'Войдите в свой аккаунт',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Этот сайт защищен reCAPTCHA и применяются Политика конфиденциальности и Условия использования Google.',
  'Ürün Kataloğumuz': 'Наш каталог продуктов',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Мы предлагаем более 8000 продуктов',
  '1,3B': '1,3К',
  'Partner': 'Партнер',
  '8,4M': '8,4М',
  'Toplam Üretim': 'Общее производство',
  '23': '23',
  'Branş': 'Филиал',
  '27,5B': '27,5К',
  'Toplam Sipariş': 'Общие заказы',
  'Connect Now': 'Подключиться сейчас',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Зарегистрируйтесь бесплатно, чтобы получить доступ ко всей информации в одном месте.',
  'Ürün Detayları': 'Детали продукта',
  'Kapat': 'Закрыть',
  'Yükleniyor...': 'Загрузка...',
  'Hata': 'Ошибка',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} товаров показано (Всего: 8000+)',
  'Şehir Seçimi': 'Выбор города',
  'Firma / Sağlık Profesyoneli': 'Компания / Медицинский специалист',
  'Yetkili Kişi': 'Уполномоченное лицо',
  'Telefon': 'Телефон',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Основная информация',
  'Ek Bilgiler': 'Дополнительная информация',
  'Faaliyet Alanı / Sektör': 'Область деятельности / Сектор',
  'Ülke Seçimi': 'Выбор страны',
  'Ülke adı veya kodu ara...': 'Поиск названия или кода страны...',
  'region.Avrupa': 'Европа',
  'region.Amerika': 'Америка',
  'region.Asya': 'Азия',
  'region.Afrika': 'Африка',
  'region.Okyanusya': 'Океания',
  'region.Diğer': 'Другое',
  'country.TR': 'Турция',
  'country.US': 'Соединенные Штаты',
  'country.DE': 'Германия',
  'country.FR': 'Франция',
  'country.GB': 'Великобритания',
  'country.IT': 'Италия',
  'country.ES': 'Испания',
  'country.RU': 'Россия',
  'country.CN': 'Китай',
  'country.JP': 'Япония',
  'country.KR': 'Южная Корея',
  'country.IN': 'Индия',
  'country.BR': 'Бразилия',
  'country.CA': 'Канада',
  'country.AU': 'Австралия',
  'Ticaret Sicil No': 'Номер торгового реестра',

  'country.TR': 'Турция',
  'country.AL': 'Албания',
  'country.DE': 'Германия',
  'country.AD': 'Андорра',
  'country.AT': 'Австрия',
  'country.BY': 'Беларусь',
  'country.BE': 'Бельгия',
  'country.BA': 'Босния и Герцеговина',
  'country.BG': 'Болгария',
  'country.CZ': 'Чехия',
  'country.DK': 'Дания',
  'country.EE': 'Эстония',
  'country.FO': 'Фарерские острова',
  'country.FI': 'Финляндия',
  'country.FR': 'Франция',
  'country.GI': 'Гибралтар',
  'country.GR': 'Греция',
  'country.GG': 'Гернси',
  'country.HR': 'Хорватия',
  'country.NL': 'Нидерланды',
  'country.IE': 'Ирландия',
  'country.ES': 'Испания',
  'country.SE': 'Швеция',
  'country.CH': 'Швейцария',
  'country.IT': 'Италия',
  'country.IS': 'Исландия',
  'country.JE': 'Джерси',
  'country.ME': 'Черногория',
  'country.LV': 'Латвия',
  'country.LI': 'Лихтенштейн',
  'country.LT': 'Литва',
  'country.LU': 'Люксембург',
  'country.HU': 'Венгрия',
  'country.MT': 'Мальта',
  'country.IM': 'Остров Мэн',
  'country.MD': 'Молдова',
  'country.MC': 'Монако',
  'country.MK': 'Северная Македония',
  'country.NO': 'Норвегия',
  'country.PL': 'Польша',
  'country.PT': 'Португалия',
  'country.RO': 'Румыния',
  'country.RU': 'Россия',
  'country.SM': 'Сан-Марино',
  'country.RS': 'Сербия',
  'country.SK': 'Словакия',
  'country.SI': 'Словения',
  'country.SJ': 'Шпицберген и Ян-Майен',
  'country.UA': 'Украина',
  'country.GB': 'Великобритания',
  'country.VA': 'Ватикан',
  'country.AX': 'Аландские острова',
  'country.US': 'Соединенные Штаты',
  'country.AS': 'Американское Самоа',
  'country.AI': 'Ангилья',
  'country.AG': 'Антигуа и Барбуда',
  'country.AR': 'Аргентина',
  'country.AW': 'Аруба',
  'country.BS': 'Багамские Острова',
  'country.BB': 'Барбадос',
  'country.BZ': 'Белиз',
  'country.BM': 'Бермудские острова',
  'country.BO': 'Боливия',
  'country.BR': 'Бразилия',
  'country.VG': 'Британские Виргинские острова',
  'country.CA': 'Канада',
  'country.KY': 'Острова Кайман',
  'country.CL': 'Чили',
  'country.CO': 'Колумбия',
  'country.CR': 'Коста-Рика',
  'country.CU': 'Куба',
  'country.CW': 'Кюрасао',
  'country.DM': 'Доминика',
  'country.DO': 'Доминиканская Республика',
  'country.EC': 'Эквадор',
  'country.SV': 'Сальвадор',
  'country.FK': 'Фолклендские острова',
  'country.GF': 'Французская Гвиана',
  'country.GD': 'Гренада',
  'country.GL': 'Гренландия',
  'country.GP': 'Гваделупа',
  'country.GT': 'Гватемала',
  'country.GY': 'Гайана',
  'country.HT': 'Гаити',
  'country.HN': 'Гондурас',
  'country.JM': 'Ямайка',
  'country.MQ': 'Мартиника',
  'country.MX': 'Мексика',
  'country.MS': 'Монтсеррат',
  'country.NI': 'Никарагуа',
  'country.PA': 'Панама',
  'country.PY': 'Парагвай',
  'country.PE': 'Перу',
  'country.PR': 'Пуэрто-Рико',
  'country.BL': 'Сен-Бартелеми',
  'country.KN': 'Сент-Китс и Невис',
  'country.LC': 'Сент-Люсия',
  'country.MF': 'Сен-Мартен',
  'country.PM': 'Сен-Пьер и Микелон',
  'country.VC': 'Сент-Винсент и Гренадины',
  'country.SX': 'Синт-Мартен',
  'country.SR': 'Суринам',
  'country.TT': 'Тринидад и Тобаго',
  'country.TC': 'Острова Теркс и Кайкос',
  'country.UY': 'Уругвай',
  'country.VE': 'Венесуэла',
  'country.VI': 'Виргинские острова США',
  'country.AF': 'Афганистан',
  'country.AZ': 'Азербайджан',
  'country.BH': 'Бахрейн',
  'country.BD': 'Бангладеш',
  'country.AE': 'Объединенные Арабские Эмираты',
  'country.BN': 'Бруней',
  'country.BT': 'Бутан',
  'country.CN': 'Китай',
  'country.TL': 'Восточный Тимор',
  'country.ID': 'Индонезия',
  'country.AM': 'Армения',
  'country.PH': 'Филиппины',
  'country.PS': 'Палестина',
  'country.GE': 'Грузия',
  'country.KR': 'Южная Корея',
  'country.IN': 'Индия',
  'country.HK': 'Гонконг',
  'country.IQ': 'Ирак',
  'country.IR': 'Иран',
  'country.IL': 'Израиль',
  'country.JP': 'Япония',
  'country.KH': 'Камбоджа',
  'country.QA': 'Катар',
  'country.KZ': 'Казахстан',
  'country.KG': 'Киргизия',
  'country.CY': 'Кипр',
  'country.KW': 'Кувейт',
  'country.KP': 'Северная Корея',
  'country.LA': 'Лаос',
  'country.LB': 'Ливан',
  'country.MO': 'Макао',
  'country.MV': 'Мальдивы',
  'country.MY': 'Малайзия',
  'country.MM': 'Мьянма',
  'country.MN': 'Монголия',
  'country.NP': 'Непал',
  'country.UZ': 'Узбекистан',
  'country.PK': 'Пакистан',
  'country.SG': 'Сингапур',
  'country.LK': 'Шри-Ланка',
  'country.SY': 'Сирия',
  'country.SA': 'Саудовская Аравия',
  'country.TJ': 'Таджикистан',
  'country.TH': 'Таиланд',
  'country.TW': 'Тайвань',
  'country.TM': 'Туркменистан',
  'country.OM': 'Оман',
  'country.JO': 'Иордания',
  'country.VN': 'Вьетнам',
  'country.YE': 'Йемен',
  'country.DZ': 'Алжир',
  'country.AO': 'Ангола',
  'country.BJ': 'Бенин',
  'country.BW': 'Ботсвана',
  'country.BF': 'Буркина-Фасо',
  'country.BI': 'Бурунди',
  'country.CV': 'Кабо-Верде',
  'country.CM': 'Камерун',
  'country.CF': 'Центральноафриканская Республика',
  'country.TD': 'Чад',
  'country.KM': 'Коморские острова',
  'country.CG': 'Республика Конго',
  'country.CD': 'Демократическая Республика Конго',
  'country.CI': 'Кот-д Ивуар',
  'country.DJ': 'Джибути',
  'country.EG': 'Египет',
  'country.GQ': 'Экваториальная Гвинея',
  'country.ER': 'Эритрея',
  'country.SZ': 'Эсватини',
  'country.ET': 'Эфиопия',
  'country.GA': 'Габон',
  'country.GM': 'Гамбия',
  'country.GH': 'Гана',
  'country.GN': 'Гвинея',
  'country.GW': 'Гвинея-Бисау',
  'country.KE': 'Кения',
  'country.LS': 'Лесото',
  'country.LR': 'Либерия',
  'country.LY': 'Ливия',
  'country.MG': 'Мадагаскар',
  'country.MW': 'Малави',
  'country.ML': 'Мали',
  'country.MR': 'Мавритания',
  'country.MU': 'Маврикий',
  'country.YT': 'Майотта',
  'country.MA': 'Марокко',
  'country.MZ': 'Мозамбик',
  'country.NA': 'Намибия',
  'country.NE': 'Нигер',
  'country.NG': 'Нигерия',
  'country.RE': 'Реюньон',
  'country.RW': 'Руанда',
  'country.SH': 'Остров Святой Елены',
  'country.ST': 'Сан-Томе и Принсипи',
  'country.SN': 'Сенегал',
  'country.SC': 'Сейшельские острова',
  'country.SL': 'Сьерра-Леоне',
  'country.SO': 'Сомали',
  'country.ZA': 'Южная Африка',
  'country.SS': 'Южный Судан',
  'country.SD': 'Судан',
  'country.TZ': 'Танзания',
  'country.TG': 'Того',
  'country.TN': 'Тунис',
  'country.UG': 'Уганда',
  'country.EH': 'Западная Сахара',
  'country.ZM': 'Замбия',
  'country.ZW': 'Зимбабве',
  'country.AU': 'Австралия',
  'country.CX': 'Остров Рождества',
  'country.CC': 'Кокосовые острова',
  'country.CK': 'Острова Кука',
  'country.FJ': 'Фиджи',
  'country.PF': 'Французская Полинезия',
  'country.GU': 'Гуам',
  'country.HM': 'Острова Херд и Макдональд',
  'country.KI': 'Кирибати',
  'country.MH': 'Маршалловы острова',
  'country.FM': 'Микронезия',
  'country.NR': 'Науру',
  'country.NC': 'Новая Каледония',
  'country.NZ': 'Новая Зеландия',
  'country.NU': 'Ниуэ',
  'country.NF': 'Остров Норфолк',
  'country.MP': 'Северные Марианские острова',
  'country.PW': 'Палау',
  'country.PG': 'Папуа-Новая Гвинея',
  'country.PN': 'Острова Питкэрн',
  'country.WS': 'Самоа',
  'country.SB': 'Соломоновы острова',
  'country.TK': 'Токелау',
  'country.TO': 'Тонга',
  'country.TV': 'Тувалу',
  'country.VU': 'Вануату',
  'country.WF': 'Уоллис и Футуна',
  'country.AQ': 'Антарктида',
  'country.BV': 'Остров Буве',
  'country.IO': 'Британская территория в Индийском океане',
  'country.TF': 'Французские Южные и Антарктические земли',
  'country.GS': 'Южная Георгия и Южные Сандвичевы острова',
};
